import CallCenterHome from "../../images/homesectionimages/CallCenterPhoto.png";
import FinanceHome    from "../../images/homesectionimages/FinancePhoto.png";
import HealthHome     from "../../images/homesectionimages/HealthCompliancePhoto.png";
import TechHome       from "../../images/homesectionimages/TechPhoto.webp";

export const techStaffData = [
    {
        id: 1,
        title: "Tech Staffing",
        link: "techstaffing",
        img: TechHome,
        subheader: "Launch your IT team to the next level.",
        text: "From programming to cybersecurity, we recruit top talent to join your tech squad."
    },

    {
        id: 2,
        title: "Finance Staffing",
        link: "financestaffing",
        img: FinanceHome,
        subheader: "Control the bottom line.",
        text: "Hire financial and accounting experts to tackle pressing money challenges head on."
    },

    {
        id: 3,
        title: "Call Center Staffing",
        link: "callcenterstaffing",
        img: CallCenterHome,
        subheader: "Revitalize your customer service.",
        text: "We connect you to resources that generate positive & lasting call center results."
    },

    {
        id: 4,
        title: "Health Compliance",
        link: "healthcompliance",
        img: HealthHome,
        subheader: "Ensure your staff's health and safety.",
        text: "Install guidelines preventing exposure to COVID-19 and other airborne diseases."
    }
]